module.exports = __webpack_public_path__ + "static/media/console-log.f6e0f5fa.png";